import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ms-layout" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_3 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "accordion-item NKT-P1" }
const _hoisted_7 = ["id", "data-bs-target", "aria-controls", "onClick"]
const _hoisted_8 = { class: "col-icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_15 = { class: "accordion-body" }

import arrow from '@/assets/svg/arrow.svg'
import { SparePart, SparePartGroups } from '@/server/MakeSenseApp-backend'
import moment from 'moment'
import { computed, ref, watch } from 'vue'
import SparePartsTable from './SparePartsTable.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SparePartsInventory',
  props: {
  inventory: Array<SparePartGroups>,
  isLoading: Boolean,
  searchValue: String
},
  setup(__props) {

var props = __props

const toggleExpanded = (index: number) => {
  if (expandedItems.value.has(index)) {
    expandedItems.value.delete(index)
  } else {
    expandedItems.value.add(index)
  }
}

const filterSparePartGroup = (sparePartGroups: SparePartGroups[] | undefined) => {
  if (sparePartGroups === undefined) {
    return []
  }
  return sparePartGroups.filter((sparePartGroup) => {
    return filteredSparePart(sparePartGroup.spareParts)?.length !== 0
  })
}

const sumofSparePartsQuantity = (spareParts: SparePart[] | undefined): number => {
  if (!spareParts) return 0

  return spareParts.reduce((total, part) => {
    const qty = Number(part.quantity)
    return total + (isNaN(qty) ? 0 : qty)
  }, 0)
}

const filteredSparePart = (spareParts: SparePart[] | undefined) => {
  if (spareParts === undefined) {
    return []
  }

  return spareParts.filter((sparePart) => {
    return (
      sparePart.subcategory?.toLowerCase().includes(props.searchValue?.toLowerCase() ?? '') ||
      sparePart.spareName?.toLowerCase().includes(props.searchValue?.toLowerCase() ?? '') ||
      sparePart.identity?.toLowerCase().includes(props.searchValue?.toLowerCase() ?? '') ||
      sparePart.description?.toLowerCase().includes(props.searchValue?.toLowerCase() ?? '') ||
      sparePart.storageDescription?.toLowerCase().includes(props.searchValue?.toLowerCase() ?? '')
    )
  })
}

const formatTimestamp = (timestamp: Date | undefined): string => {
  if (!timestamp) return '-'
  return moment(timestamp).format('YYYY-MM-DD')
}

const expandedItems = ref(new Set<number>())

const isExpanded = (index: number) => {
  return expandedItems.value.has(index)
}

// Computed value to track when displayed groups actually change
const displayedGroups = computed(() => filterSparePartGroup(props.inventory))

// Clear expanded state only when displayed content changes
watch(displayedGroups, () => {
  expandedItems.value.clear()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", {
            class: "spinner-border",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (!__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"row ms-bottom-border NKT-P1-medium\" data-v-263bcbf7><div data-v-263bcbf7></div><div class=\"col\" data-v-263bcbf7>Spare Name</div><div class=\"col\" data-v-263bcbf7>Earliest Expiry</div><div class=\"col\" data-v-263bcbf7>Location</div><div class=\"col\" data-v-263bcbf7>Total quantity</div></div>", 1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterSparePartGroup(__props.inventory), (elm, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "row pt-2"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "accordion",
                  id: 'spare-parts-accordion-' + index
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "d-flex justify-content-between align-items-center ms-accordion-item-header sticky-top",
                      id: 'spare-parts-accordion-label-' + index,
                      "data-bs-toggle": "collapse",
                      "data-bs-target": '#spare-parts-accordion-collapse' + index,
                      "aria-expanded": false,
                      "aria-controls": 'spare-parts-accordion-collapse' + index,
                      onClick: ($event: any) => (toggleExpanded(index))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: _unref(arrow),
                          class: _normalizeClass(["ms-rotate-icon", { rotated: isExpanded(index) }])
                        }, null, 10, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(elm.spareName), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'expired-date-cell': elm.isExpired })
                        }, _toDisplayString(elm.earliestExpiry ? formatTimestamp(elm.earliestExpiry) : 'No Limit'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(elm.location), 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(sumofSparePartsQuantity(elm.spareParts)), 1)
                    ], 8, _hoisted_7),
                    _createElementVNode("div", {
                      id: 'spare-parts-accordion-collapse' + index,
                      class: "accordion-collapse collapse",
                      "aria-labelledby": 'spare-parts-accordion-label-' + index,
                      "data-bs-parent": 'spare-parts-accordion-' + index
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(SparePartsTable, {
                          class: "mt-4",
                          isLoading: __props.isLoading,
                          spareparts: filteredSparePart(elm.spareParts),
                          idindex: index
                        }, null, 8, ["isLoading", "spareparts", "idindex"])
                      ])
                    ], 8, _hoisted_14)
                  ])
                ], 8, _hoisted_5)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})